import React from 'react';

import './Field.css';
import FieldBase from './Base';
/* import FieldSelectComponent from './Select';
import FieldTextComponent from './Text'; */

// tslint:disable:variable-name
/* export const FieldText = FieldTextComponent;
export const FieldSelect = FieldSelectComponent; */
// tslint:enable:variable-name
export interface IFieldValidationContext {
  bind: (field: FieldBase<any, any>) => void;
  unbind: (field: FieldBase<any, any>) => void;
}

// tslint:disable-next-line:variable-name
export const FieldValidation = React.createContext<IFieldValidationContext>(null);


// WEBPACK FOOTER //
// ./src/components/Field/index.tsx